export async function incorrectGameId (rlxlauncher, settings) {
    const gameid = rlxlauncher.gameid;
    const partnerid = rlxlauncher.partnerid;

    const bodyToSend = {
        "gameref": gameid,
        "partnerid": partnerid,
        "ticket": "mock_incorrect_gameid",
    };

    await fetch(new URL('capi/1.0/casino/token/gettoken',settings.clientApiURL), {
        "body": JSON.stringify(bodyToSend),
        "method": "POST",
        "mode": "cors"
    });

    throw new Error('Oops, this link is looking in the wrong place. Please contact casino customer support.');
}